import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider } from 'react-router'

import { router } from './router'
import { WorkspaceSessionProvider } from './workspace/workspaceSession'
import './styles.css'

// One client, the predecessor's temperament: retry once (a reconciliation
// screen that silently retries five times feels hung, not resilient) and no
// global focus refetch — the queries that WANT focus refresh say so
// themselves (`refetchOnWindowFocus: true` in api/hooks.ts).
const queryClient = new QueryClient({
  defaultOptions: {
    queries: { retry: 1, refetchOnWindowFocus: false },
  },
})

const root = document.getElementById('root')
if (!root) throw new Error('#root is missing from index.html')

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <WorkspaceSessionProvider>
        <RouterProvider router={router} />
      </WorkspaceSessionProvider>
    </QueryClientProvider>
  </StrictMode>,
)
